import React, { useState, useEffect } from 'react';
import './ListUploads.css';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';

const ListUploads = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedSections, setExpandedSections] = useState({});
  const [initialLoad, setInitialLoad] = useState(true);

  const { product, serialNumber } = useParams();
  
  // Group the data by product number and serial number
  const groupedData = data.reduce((result, item) => {
    const key = `${item.product}-${item.serial_number}`;
    if (!result[key]) {
      result[key] = [];
    }
    result[key].push(item);
    return result;
  }, {});

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://sucmhxbjlk.execute-api.us-east-1.amazonaws.com/prod/viewuploads');
      if (response.ok) {
        const jsonBody = await response.json();
        const jsonData = JSON.parse(jsonBody.body);

        // Update the data state
        setData(jsonData.message);
      } else {
        console.error('Failed to fetch data');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      // Loading state is set to false in the cleanup function of useEffect
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(); // Fetch data when the component mounts
  }, []); // Empty dependency array to run once when the component mounts

  useEffect(() => {
    // Set the first grouping to be expanded on initial load
    if (initialLoad && Object.keys(expandedSections).length === 0 && Object.keys(groupedData).length > 0) {
      const firstKey = Object.keys(groupedData)[0];
      setExpandedSections({ [firstKey]: true });
      setInitialLoad(false);
    }
  }, [expandedSections, initialLoad, groupedData]);

  // Function to toggle the expanded state of a section
  const toggleSection = (key) => {
    setExpandedSections((prevState) => {
      const newSections = { [key]: !prevState[key] };
      // Set all other sections to collapsed if the current section is expanded
      if (newSections[key]) {
        Object.keys(prevState).forEach((sectionKey) => {
          if (sectionKey !== key) {
            newSections[sectionKey] = false;
          }
        });
      }
      return newSections;
    });
  };

  // Sort data within each group by File Date in descending order
  for (const key in groupedData) {
    groupedData[key].sort((a, b) => new Date(b.datetime_file) - new Date(a.datetime_file));
  }

  return (
    <div className="uploaded-files-container">
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="uploaded-files-table-container">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Upload #</th>
                <th>Product</th>
                <th>Serial Number</th>
                <th>Upload Date</th>
                <th>File Date</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(groupedData).length > 0 ? (
                Object.keys(groupedData).map((key, index) => (
                  <React.Fragment key={index}>
                    <tr>
                      <th
                        colSpan="6"
                        style={{ cursor: 'pointer' }}
                        onClick={() => toggleSection(key)}
                      >
                        {expandedSections[key] ? '▼' : '►'}{' '}
                        Product: {groupedData[key][0].product}, Serial Number:{' '}
                        {groupedData[key][0].serial_number} ({groupedData[key].length} Data Uploads)
                      </th>
                    </tr>
                    {expandedSections[key] &&
                      groupedData[key].map((item, subIndex) => (
                        <tr key={subIndex}>
                          <td>{item.id}</td>
                          <td>{item.product}</td>
                          <td>{item.serial_number}</td>
                          <td>{item.datetime_upload}</td>
                          <td>{item.datetime_file}</td>
                          <td>
                            <Link to={`/viewdata/:${item.id}`}> Chart</Link>
                          </td>
                        </tr>
                      ))}
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No data available</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default ListUploads;
